<template>
  <div>
    <v-text-field
      v-model="lazyVal.name"
      label="Title"
    ></v-text-field>

    <v-input
      name="pnc_type"
      :value="lazyVal"
      single-line
      :messages="pncTypeMessages"
    >
      <v-expansion-panels>
        <isrs-pnc-type-card
          type="locationId"
          itemKey="0"
          itemText="name"
          itemValue="id"
          headline="Location"
          text="Explore hundreds of Locations ready to connect with this Parcel Number Container! For more information visit the Unique technical manual."
          :query="handleQueryLocations"
          :value="location"
          @input="updateType"
          :fields="['id', 'code']"
        >
        </isrs-pnc-type-card>

        <isrs-pnc-type-card
          type="ownerId"
          itemKey="1"
          itemText="name"
          itemValue="id"
          headline="Owner"
          text="Restrict this Parcel Number Container to the following owner."
          :query="handleQueryOwners"
          :value="owner"
          @input="updateType"
          :fields="['id', 'code']"
        >
        </isrs-pnc-type-card>

        <isrs-pnc-type-card
          type="customerId"
          itemKey="2"
          itemText="customerName1"
          itemValue="customerId"
          headline="Customer"
          text="Only these customers can use this Parcel Number Container."
          :query="handleQueryCustomers"
          :value="customer"
          @input="updateType"
          :fields="['customerName1']"
        >
        </isrs-pnc-type-card>

        <isrs-pnc-type-card
          type="outboundOwnerId"
          itemKey="3"
          itemText="name"
          itemValue="id"
          headline="Outbound Owner"
          text="Select the owner for which the outbound parcel number container shall be created."
          :query="handleQueryOwners"
          :value="outboundOwner"
          @input="updateType"
          :fields="['id', 'code']"
        >
        </isrs-pnc-type-card>

        <isrs-pnc-type-card
          type="inboundOwnerId"
          itemKey="4"
          itemText="name"
          itemValue="id"
          headline="Inbound Owner"
          text="Select the owner for which the inbound parcel number container shall be created."
          :query="handleQueryOwners"
          :value="inboundOwner"
          @input="updateType"
          :fields="['id', 'code']"
        >
        </isrs-pnc-type-card>

      </v-expansion-panels>
    </v-input>

    <v-btn @click.native="updatePNC()" block color="success">Save</v-btn>
  </div>
</template>

<script>
import IsrsPncTypeCard from './IsrsPncTypeCard.vue'

export default {
  components: {IsrsPncTypeCard},

  props: {
    value: {
      type: [Object, undefined],
      default: undefined
    }
  },

  data() {
    return {
      lazyVal: this.sanitizeVal(this.value),
      newPncTypesPanel: undefined,
      customer: undefined,
      owner: undefined,
      location: undefined,
      outboundOwner: undefined,
      inboundOwner: undefined
    }
  },

  watch: {
    value(val, oldVAl) {
      this.lazyVal = this.sanitizeVal(this.value)
    },

    lazyVal(val, oldVal) {
      if(val.customerId && val.customerId !== oldVal.customerId) {
        this.dataService.getCustomer(val.customerId)
          .then(result => result.data)
          .then( data => {
            this.customer = data
          })
      }

      if(val.ownerId && val.ownerId !== oldVal.ownerId) {
        this.dataService.getOwner(val.ownerId)
          .then(result => result.data)
          .then(data => {
            this.owner = data
          })
      }

      if(val.locationId && val.locationId !== oldVal.locationId) {
        this.dataService.getLocation(val.locationId)
          .then(result => result.data)
          .then(data => {
            //const {id: ownerCode, code: ownerNo, name: ownerName} = data
            this.location = data
          })
      }

      if(val.outboundOwnerId && val.outboundOwnerId !== oldVal.outboundOwnerId) {
        this.dataService.getOwner(val.outboundOwnerId)
          .then(result => result.data)
          .then(data => {
            this.outboundOwner = data
          })
      }

      if(val.inboundOwnerId && val.inboundOwnerId !== oldVal.inboundOwnerId) {
        this.dataService.getOwner(val.inboundOwnerId)
          .then(result => result.data)
          .then(data => {
            this.inboundOwner = data
          })
      }
    }
  },

  computed: {
    pncTypeMessages() {
      const entries = Object.entries(this.lazyVal)
      return entries
        .filter(item => !!item[1])
        .map(([k, v]) => `${k}: ${v}`)
        .join(", ")
    }
  },

  methods: {
    sanitizeVal(val) {
      const {name, customerId, locationId, ownerId, outboundOwnerId, inboundOwnerId} = val
      return {name, customerId, locationId, ownerId, outboundOwnerId, inboundOwnerId}
    },

    updateType(type) {
      type.name = this.lazyVal.name
      this.lazyVal = this.sanitizeVal(type)
    },

    handleQueryLocations(val) {
      return this.dataService.getLocationsBySearchTerm(val).then( result => result.data.data)
    },

    handleQueryOwners(val) {
      return this.dataService.getOwnersBySearchTerm(val).then( result => result.data.data)
    },

    handleQueryCustomers(val) {
      return this.dataService.searchCustomers(val)
        .then( result => result.data.content)
    },

    pncAutocompleteLocationQuery(val) {
      this.pncAutocompleteLocationLoading = true
      this.dataService.getLocationsBySearchTerm(val).then( result => result.data.data).then( data => {
        this.pncAutocompleteLocationItems = data
        this.pncAutocompleteLocationLoading = false
      })
    },

    queryPagination () {
      let {sortBy, descending, page, rowsPerPage} = this.pagination

      if (descending) {
        sortBy = `${sortBy},desc`
      }

      if (this.dataService) {
        this.loading = true
        return this.dataService.getParcelNumberContainers(false, page, rowsPerPage, sortBy)
      }
      return Promise.reject('dataservice not ready')
    },

    updateDataTable (result) {
      this.loading = false
      this.items = result.data.content
      this.totalItems = result.data.totalElements
      return result
    },


    validateRequired (fieldName) {
      return (this[fieldName] && this[fieldName].length > 0) || 'This field is required'
    },

    validateMax (fieldName, max) {
      return (this[fieldName] && this[fieldName].length <= max) || `This field has a max length of ${max} characters`
    },

    savePnc() {
      const payload = Object.assign({name: this.pncTitle, type: "FIXME"}, this.pncType)

      this.dataService.addParcelNumberContainer(payload).then( result => {
        this.pncType = undefined
        this.pncType = ''
        this.add_parcel_number_container_dialog = false
        this.queryPagination().then(this.updateDataTable)
      })
    },

    getValue(type, item) {
      switch(type) {
        case 'OWNER': return item.ownerId
        case 'LOCATION': return item.locationId
        case 'CUSTOMER': return item.customerId
      }
    },

    updatePNC() {
      const {id} = this.value
      return this.dataService.updateParcelNumberContainer(id, this.lazyVal)
        .then(() => {
          console.log('updated')
        })
    }
  },
}
</script>



// WEBPACK FOOTER //
// IsrsParcelNumberContainer.vue?59ce995f